export const AUTH = 'AUTH/auth';
export const LOGIN = 'AUTH/login';
export const MFA_LOGIN = 'AUTH/mfa_login';
export const LOGOUT = 'AUTH/logout';
export const FORGOT_PASS = 'AUTH/forgot_pass';
export const USER_PROFILE = 'AUTH/user_profile';
export const VERIFY_MOBILE = 'AUTH/verify_mobile';

export const GET_DEMO_LIST = 'DEMO/get_demo_list';
export const GET_DEMO_INFO = 'DEMO/get_demo_info';
export const CREATE_DEMO = 'DEMO/create_demo';
export const UPDATE_DEMO = 'DEMO/update_demo';

export const VERIFY_LOGIN = 'AUTH/verify_login';
export const UPDATE_MFA_TYPE = 'AUTH/update_mfa_type';

export const FORM_DATA = {
  title: '',
  image_url: '',
  height: '',
};

export const mfaSettings = [
  {
    preferred_mfa: 'google_authenticator',
    icon: "fa-solid fa-key",
    title: "Authenticator App",
    description: "Use an app on your phone to generate verification codes when logging in."
  },
  // {
  //   id: 2,
  //   icon: "fa-solid fa-comment-dots",
  //   title: "SMS Authentication",
  //   description: "Enter a one-time pin (OTP) sent to your registered mobile number."
  // },
  {
    preferred_mfa: 'email_otp',
    icon: "fa-solid fa-envelope",
    title: "Email Authentication",
    description: "Enter a one-time pin (OTP) sent to your registered email address."
  }
];

export const GENERATE_2FA = 'AUTH/generate_2fa';
export const ENABLE_2FA = 'AUTH/enable_2fa';
export const DISABLE_2FA = 'AUTH/disable_2fa';
export const RESEND_OTP = 'AUTH/resend_otp';
export const EMAIL_2FA = 'AUTH/email_2fa';
